import { CertStatus } from 'data/certStatus/certStatus.types';
import { SecurityInfo } from 'data/securityInfo/securityInfo.types';
import { TlsProfile } from './tlsProfile.types';

// eslint-disable-next-line import/prefer-default-export
export function adaptToCreate(distributorConfig: TlsProfile): TlsProfile {
  return distributorConfig;
}

export function getCertStatusPayload(tlsProfile: TlsProfile | SecurityInfo): CertStatus {
  const COMMONNAME = tlsProfile.commonName ? tlsProfile.commonName : `${tlsProfile.aftype}-${tlsProfile.litype}`;
  return {
    id: tlsProfile.id,
    CERTID: '',
    AFTYPE: tlsProfile.aftype ?? '',
    LITYPE: tlsProfile.litype as 'INI1' | 'INI2' | 'INI3',
    COMMONNAME,
    ORGANIZATION: '',
    ORGUNIT: '',
    COUNTRY: '',
    STATE: '',
    LOCALITY: '',
    EMAIL: '',
    SAN: tlsProfile.san ?? '',
    VALIDDAYS: '730',
    KEYALGORITHM: tlsProfile.keyalgorithm ?? 'RSA_4096',
    DIGEST: 'SHA256',
    SERIALNUMBER: '',
    STATUS: 'UNKNOWN',
    ACTION: 'NONE'
  };
}

export function adaptCertStatusGridData(certs: CertStatus[] = [], tlsProfile: TlsProfile) {
  const filteredCerts = (certs ?? []).filter((c) => c.AFTYPE === tlsProfile.aftype && c.LITYPE === tlsProfile.litype);
  return filteredCerts.map((c) => {
    return {
      id: c.CERTID as string,
      commonName: c.COMMONNAME,
      validDays: c.VALIDDAYS,
      status: c.STATUS,
      errorMsg: c.ERRMSG ?? '',
      expireDate: c.EXPIREDATE ?? ''
    };
  });
}
